/*
 * Harry in the site search (Plastics Co UK).
 * - The header search's live panel (assets/pco-search.js: form.pcos, results in [data-pcos-live]) and the
 *   menu and mobile searches (assets/pco-nav.js: form.pcon-search, results in [data-pcon-results]) get an
 *   "Ask Harry" row on top of every set of results, and a bigger invitation when nothing matches.
 * - Questions typed into any search ("which plastic for a chopping board?", "600 x 400 polycarbonate 5mm
 *   price") open Harry instead of a results page; product searches ("acetal rod 30mm") still go to the
 *   normal search.
 * - The search results page gets a Harry box under the heading (and a stronger one when nothing is found).
 * Loaded by snippets/harry.liquid after harry.js. Everything waits for window.HarryChat.
 */
(function () {
  'use strict';
  var QUESTION = /^(how|what|whats|what's|which|why|when|where|who|can|could|do|does|did|is|are|should|will|would|i|im|i'm|my|we|our|help|need|recommend|best|tell|explain|advice|difference|compare|price|quote|cost)\b/i;

  function isQuestion(q) {
    q = (q || '').trim();
    if (!q) return false;
    if (q.indexOf('?') !== -1) return true;
    if (QUESTION.test(q)) return true;
    // Long phrases are usually a job description ("sheet for a machine guard that gets hit by swarf"),
    // short ones are product searches ("acetal rod 30mm").
    return q.split(/\s+/).length >= 7;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function harry() { return window.HarryChat; }
  function ask(q, source, input) {
    var a = harry();
    if (!a) return false;
    closeDropdown(input);
    a.open(q, source);
    return true;
  }

  var forms = [].slice.call(document.querySelectorAll('form.pcos, form.pcon-search'));
  function inputOf(form) { return form.querySelector('input[name="q"]'); }
  // Where each search shows its live results.
  function panelOf(form) {
    if (form.classList.contains('pcos')) return form.querySelector('[data-pcos-live]');
    var live = form.closest('[data-pcon-live]');
    return live ? live.querySelector('[data-pcon-results]') : null;
  }
  function noMatches(panel) {
    return !!panel.querySelector('.pcos-none, .pcon-none, .pcon-empty') ||
      (!panel.querySelector('a[href*="/products/"], a[href*="/collections/"]') && /no match|no result|nothing found/i.test(panel.textContent));
  }

  function closeDropdown(input) {
    if (!input) return;
    input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    input.blur();
  }

  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9zM19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9z"/></svg>';
  var MIC = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';

  // ---------- "Ask Harry" row in the search panels ----------
  function harryRow(q, none) {
    var title = none ? 'No exact match? Ask Harry' : 'Ask Harry: “' + esc(q) + '”';
    var sub = none ? 'Tell him the job and the size: he’ll pick the right plastic and price it'
      : 'Our AI plastics specialist picks the right material, size and price in seconds';
    return '<button type="button" class="harry-sr' + (none ? ' harry-sr--big' : '') + '" data-harry-sr="' + esc(q) + '">' +
      '<span class="harry-sr__av" aria-hidden="true">H</span>' +
      '<span class="harry-sr__txt"><b>' + title + '</b><small>' + sub + '</small></span>' +
      '<span class="harry-sr__go" aria-hidden="true">' + SPARK + '</span></button>';
  }
  function decorate(form) {
    var input = inputOf(form), panel = panelOf(form), q = input ? input.value.trim() : '';
    if (!panel || q.length < 2 || !panel.firstElementChild) return;
    var none = noMatches(panel);
    var row = panel.querySelector('.harry-sr');
    if (row && row.getAttribute('data-harry-sr') === q && row.classList.contains('harry-sr--big') === none) return;
    if (row) row.remove();
    panel.insertAdjacentHTML('afterbegin', harryRow(q, none));
  }
  forms.forEach(function (form) {
    var panel = panelOf(form);
    if (!panel) return;
    var pending = 0;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(function () { decorate(form); }, 30); })
      .observe(panel, { childList: true, subtree: true });
  });

  // Window capture: runs before any of the theme's own handlers (pco-search.js stops submit and click
  // events at the form).
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-harry-sr]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var q = b.getAttribute('data-harry-sr');
    if (b.classList.contains('harry-sr--big') && q) q = 'Find me the right product for: ' + q;
    var form = b.closest('form.pcos, form.pcon-search') || (b.closest('[data-pcon-live]') || document).querySelector('form.pcon-search');
    ask(q || null, 'search_row', form ? inputOf(form) : null);
  }, true);

  // ---------- questions typed into the search open Harry ----------
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || forms.indexOf(form) < 0) return;
    var input = inputOf(form), q = input ? input.value.trim() : '';
    if (!isQuestion(q) || !harry()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: 'search_question', sn_source: 'harry' }); } catch (err) {}
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    ask(q, 'search_question', input);
  }, true);

  // ---------- search results page ----------
  function searchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q || document.querySelector('.harry-sp')) return;
    var h1 = document.querySelector('main h1');
    var host = h1 && (h1.closest('header, .page-header, .section__header, .page__header') || h1);
    if (!host) return;
    var none = !document.querySelector('main a[href*="/products/"]');
    var box = document.createElement('section');
    box.className = 'harry-sp' + (none ? ' harry-sp--none' : '');
    var lead = none ? 'No exact match for “' + esc(q) + '”, but Harry can help'
      : 'Not sure which of these is right for your job?';
    var chips = none ? ['Find me the right product for: ' + q, 'Can you cut it to my size?']
      : ['Which of these is best for my job?', 'Cheapest one in my size?', 'Can you cut it to size?'];
    box.innerHTML = '<span class="harry-sp__av" aria-hidden="true">H</span><div class="harry-sp__body">' +
      '<b class="harry-sp__lead">' + lead + '</b>' +
      '<p>Ask Harry, our AI plastics specialist. Tell him the job and the size and he’ll pick the right material, find the best price and put it in your basket.</p>' +
      '<div class="harry-sp__chips">' + chips.map(function (c) {
        var full = c.indexOf(q) === -1 ? c + ' (I searched for “' + q + '”)' : c;
        return '<button type="button" class="harry-sp__chip" data-harry-sr="' + esc(full) + '">' + esc(c) + '</button>';
      }).join('') + '<button type="button" class="harry-sp__talk" data-harry-talk>' + MIC + 'Talk to Harry</button></div></div>';
    host.parentNode.insertBefore(box, host.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-harry-talk]');
    if (!t || !harry()) return;
    e.preventDefault();
    harry().talk('search_page');
  });

  function ready() { searchPage(); }
  // harry.js is deferred before this file, so HarryChat exists by now; wait a moment if it doesn't.
  function start(tries) { if (harry() || tries > 40) ready(); else setTimeout(function () { start(tries + 1); }, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(0); }); else start(0);
})();
